import { useState } from "react";
import Modal from "../../../../components/lib/modal";
import CustomButton from "../../../../components/lib/customButton";

export default function BatchStatusChangeModal({ isOpen, onClose, selectedUsers, onConfirm }) {
    const [isActive, setIsActive] = useState(true);

    const handleConfirm = () => {
        onConfirm(isActive);
    };

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={onClose}
            title="Alteração de Status em Massa"
            hideFooter
            maxWidth="max-w-md"
        >
            <div className="flex flex-col gap-4">
                <p className="text-gray-600">
                    Você selecionou <strong>{selectedUsers?.length || 0}</strong> usuários.
                    Deseja alterar o status de todos eles para:
                </p>

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">Novo Status</label>
                    <select
                        className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none"
                        value={isActive}
                        onChange={(e) => setIsActive(e.target.value === 'true')}
                    >
                        <option value="true">Ativo</option>
                        <option value="false">Inativo</option>
                    </select>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mt-2">
                    <p className="text-sm text-yellow-700">
                        Atenção: Usuários inativos não poderão acessar o sistema.
                    </p>
                </div>

                <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-gray-100">
                    <CustomButton
                        onClick={onClose}
                        text="Cancelar"
                        buttonType="cancel"
                    />
                    <CustomButton
                        onClick={handleConfirm}
                        text="Confirmar Alteração"
                        buttonType="confirm"
                    />
                </div>
            </div>
        </Modal>
    );
}